import React from 'react';
import PropTypes from 'prop-types';
import FileUploader from 'Components/Files/Uploader';

function Uploader({ url, additionalFormData, ...rest }) {
  return (
    <FileUploader url={url} additionalFormData={additionalFormData} params={null} {...rest} />
  );
}

Uploader.defaultProps = {
  url: '',
  additionalFormData: {},
};

Uploader.propTypes = {
  url: PropTypes.string,
  additionalFormData: PropTypes.object,
};

export default Uploader;
